import { buildOrgUrl } from "@/utils/navigation/orgUrl";

type RouterLike = { push: (location: string) => unknown };
type RedirectDeps = {
  router: RouterLike;
  setCustomer?: (payload: { id: string; name: string }) => unknown;
  clearAzureCache?: () => unknown;
  clearLicenceCache?: () => unknown;
};

export const redirectToCustomerUsage = (
  row: { id: string; name: string },
  { router, setCustomer, clearAzureCache, clearLicenceCache }: RedirectDeps,
) => {
  clearAzureCache?.();
  clearLicenceCache?.();
  setCustomer?.(row);

  return router.push(buildOrgUrl("customer", row.id, "license_usage"));
};
